import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { HttpClient } from '@angular/common/http';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  GridStateChange
} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpirelease, bmdashboardFilterValue, year } from '../../../models/slakpi';
import { division, department } from '../../../models/admin';

declare var google: any;
@Component({
  selector: 'app-bench-mark-navigation',
  templateUrl: './bench-mark-navigation.component.html',
  styleUrls: ['./bench-mark-navigation.component.css']
})
export class BenchMarkNavigationComponent implements OnInit {

  public gridApi;
  public gridColumnApi;

  public columnDefs;
  public defaultColDef;
  public rowData: [];
  public businessDivisionUno: any;
  public businessDeptUno: any;
  public trendUno: any;
  public yearUno: any;
  public division_data: any;
  public department_data: any;
  public trend_data: any;
  public yearData: any;

  public count_data: any;
  public position_data: any;
  public peer_data: any;
  public map_data: any;

  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  public isBMChambion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMAdmin: boolean = false;
  public isBMVisitor: boolean = false;

  //BenchMark
  public IsShow_BMMasters: boolean = false;
  public IsShow_BMMetadata: boolean = false;
  public IsShow_BMKPITarget: boolean = false;
  public IsShow_BMKPIDataAcquisition: boolean = false;
  public IsShow_BMKPIInbox: boolean = false;
  public IsShow_BMTrackingSheet: boolean = false;
  public IsShow_BMKPIPosition: boolean = false;
  public IsShow_IncomingBMRequest: boolean = false;
  public IsShow_BMIncomingVisitTransaction: boolean = false;
  public IsShow_OutgoingBMRequest: boolean = false;
  public IsShow_PracticeBMSetup: boolean = false;
  public IsShow_PracticeBMApproval: boolean = false;
  public IsShow_PracticeBM: boolean = false;
  public IsShow_AnnualPerformanceBM: boolean = false;
  public IsShow_AnnualPracticeBM: boolean = false;
  public IsShow_AnnualOutingVisit: boolean = false;
  public IsShow_AwarenessSession: boolean = false;
  public IsShow_BMRequest: boolean = false;
  public IsShow_BMIncomingRequest: boolean = false;
  public IsShow_BMOutgoingRequest: boolean = false;
  public IsShow_FileManager: boolean = false;

  public IsShow_PerformanceBenchmarkDashboard: boolean = false;
  public IsShow_PracticeBMDashboard: boolean = false;
  public IsShow_IncomingBMdashboard: boolean = false;
  public IsShow_OutgoinginternalBMDashboard: boolean = false;
  public IsShow_AwarnessSession: boolean = false;
  public IsShow_AddincomingBMrequest: boolean = false;
  constructor(public restApi: BMApiService, public restAdminApi: AdminApiService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.isAdmin = (this.user != null && this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;
    if (this.user.role == 'BM Champions')
      this.isBMChambion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }
    //Check if the current user is admin
    if (!this.isAdmin) {
      this.CheckReadAccess();
    }
    else {
     

      this.IsShow_BMMasters = true;
      this.IsShow_BMMetadata = true;
      this.IsShow_BMKPITarget = true;
      this.IsShow_BMKPIDataAcquisition = true;
      this.IsShow_BMKPIInbox = true;
      this.IsShow_BMTrackingSheet = true;
      this.IsShow_BMKPIPosition = true;
      this.IsShow_IncomingBMRequest = true;
      this.IsShow_BMIncomingVisitTransaction = true;
      this.IsShow_OutgoingBMRequest = true;
      this.IsShow_PracticeBMSetup = true;
      this.IsShow_PracticeBMApproval = true;
      this.IsShow_PracticeBM = true;
      this.IsShow_AnnualPerformanceBM = true;
      this.IsShow_AnnualPracticeBM = true;
      this.IsShow_AnnualOutingVisit = true;
      
      this.IsShow_BMRequest = true;
      this.IsShow_BMOutgoingRequest = true;
      this.IsShow_FileManager = true;
      this.IsShow_PerformanceBenchmarkDashboard = true;
      this.IsShow_PracticeBMDashboard = true;
      this.IsShow_IncomingBMdashboard = true;
      this.IsShow_OutgoinginternalBMDashboard = true;
      this.IsShow_AwarnessSession = true;
      this.IsShow_AddincomingBMrequest = true;
    }
  }
  //Validate Read Access and control all the page level permission
  CheckReadAccess() {


    //BenchMark
    let userPermissionData_IsShow_BMMasters = this.userService.getUserRights("Benchmark Masters");
    if (userPermissionData_IsShow_BMMasters != null && userPermissionData_IsShow_BMMasters != undefined && userPermissionData_IsShow_BMMasters.length > 0) {
      this.IsShow_BMMasters = (userPermissionData_IsShow_BMMasters[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMMetadata = this.userService.getUserRights("Benchmarking Metadata");
    if (userPermissionData_IsShow_BMMetadata != null && userPermissionData_IsShow_BMMetadata != undefined && userPermissionData_IsShow_BMMetadata.length > 0) {
      this.IsShow_BMMetadata = (userPermissionData_IsShow_BMMetadata[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMKPITarget = this.userService.getUserRights("Benchmarking KPI Target");
    if (userPermissionData_IsShow_BMKPITarget != null && userPermissionData_IsShow_BMKPITarget != undefined && userPermissionData_IsShow_BMKPITarget.length > 0) {
      this.IsShow_BMKPITarget = (userPermissionData_IsShow_BMKPITarget[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMKPIDataAcquisition = this.userService.getUserRights("KPI Data Acquisition");
    if (userPermissionData_IsShow_BMKPIDataAcquisition != null && userPermissionData_IsShow_BMKPIDataAcquisition != undefined && userPermissionData_IsShow_BMKPIDataAcquisition.length > 0) {
      this.IsShow_BMKPIDataAcquisition = (userPermissionData_IsShow_BMKPIDataAcquisition[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMKPIInbox = this.userService.getUserRights("KPI Inbox");
    if (userPermissionData_IsShow_BMKPIInbox != null && userPermissionData_IsShow_BMKPIInbox != undefined && userPermissionData_IsShow_BMKPIInbox.length > 0) {
      this.IsShow_BMKPIInbox = (userPermissionData_IsShow_BMKPIInbox[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMTrackingSheet = this.userService.getUserRights("Performance BM Tracking sheet");
    if (userPermissionData_IsShow_BMTrackingSheet != null && userPermissionData_IsShow_BMTrackingSheet != undefined && userPermissionData_IsShow_BMTrackingSheet.length > 0) {
      this.IsShow_BMTrackingSheet = (userPermissionData_IsShow_BMTrackingSheet[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMKPIPosition = this.userService.getUserRights("KPI Position");
    if (userPermissionData_IsShow_BMKPIPosition != null && userPermissionData_IsShow_BMKPIPosition != undefined && userPermissionData_IsShow_BMKPIPosition.length > 0) {
      this.IsShow_BMKPIPosition = (userPermissionData_IsShow_BMKPIPosition[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_IncomingBMRequest = this.userService.getUserRights("Incoming Benchmarking Request");
    if (userPermissionData_IsShow_IncomingBMRequest != null && userPermissionData_IsShow_IncomingBMRequest != undefined && userPermissionData_IsShow_IncomingBMRequest.length > 0) {
      this.IsShow_IncomingBMRequest = (userPermissionData_IsShow_IncomingBMRequest[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_BMIncomingVisitTransaction = this.userService.getUserRights("Incoming Benchmarking Request Transaction");
    if (userPermissionData_IsShow_BMIncomingVisitTransaction != null && userPermissionData_IsShow_BMIncomingVisitTransaction != undefined && userPermissionData_IsShow_BMIncomingVisitTransaction.length > 0) {
      this.IsShow_BMIncomingVisitTransaction = (userPermissionData_IsShow_BMIncomingVisitTransaction[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_OutgoingBMRequest = this.userService.getUserRights("Outgoing / Internal BM Request");
    if (userPermissionData_IsShow_OutgoingBMRequest != null && userPermissionData_IsShow_OutgoingBMRequest != undefined && userPermissionData_IsShow_OutgoingBMRequest.length > 0) {
      this.IsShow_OutgoingBMRequest = (userPermissionData_IsShow_OutgoingBMRequest[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_PracticeBMSetup = this.userService.getUserRights("Practice Benchmark Setup");
    if (userPermissionData_IsShow_PracticeBMSetup != null && userPermissionData_IsShow_PracticeBMSetup != undefined && userPermissionData_IsShow_PracticeBMSetup.length > 0) {
      this.IsShow_PracticeBMSetup = (userPermissionData_IsShow_PracticeBMSetup[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_PracticeBMApproval = this.userService.getUserRights("Practice Benchmark Approval");
    if (userPermissionData_IsShow_PracticeBMApproval != null && userPermissionData_IsShow_PracticeBMApproval != undefined && userPermissionData_IsShow_PracticeBMApproval.length > 0) {
      this.IsShow_PracticeBMApproval = (userPermissionData_IsShow_PracticeBMApproval[0].showPage == 1) ? true : false;
    }
    
    let userPermissionData_IsShow_PracticeBM = this.userService.getUserRights("Practice Benchmark Status");
    if (userPermissionData_IsShow_PracticeBM != null && userPermissionData_IsShow_PracticeBM != undefined && userPermissionData_IsShow_PracticeBM.length > 0) {
      this.IsShow_PracticeBM = (userPermissionData_IsShow_PracticeBM[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_AnnualPerformanceBM = this.userService.getUserRights("Annual Performance BM");
    if (userPermissionData_IsShow_AnnualPerformanceBM != null && userPermissionData_IsShow_AnnualPerformanceBM != undefined && userPermissionData_IsShow_AnnualPerformanceBM.length > 0) {
      this.IsShow_AnnualPerformanceBM = (userPermissionData_IsShow_AnnualPerformanceBM[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_AnnualPracticeBM = this.userService.getUserRights("Annual Practice BM");
    if (userPermissionData_IsShow_AnnualPracticeBM != null && userPermissionData_IsShow_AnnualPracticeBM != undefined && userPermissionData_IsShow_AnnualPracticeBM.length > 0) {
      this.IsShow_AnnualPracticeBM = (userPermissionData_IsShow_AnnualPracticeBM[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_AnnualOutingVisit = this.userService.getUserRights("Annual Outing Visit");
    if (userPermissionData_IsShow_AnnualOutingVisit != null && userPermissionData_IsShow_AnnualOutingVisit != undefined && userPermissionData_IsShow_AnnualOutingVisit.length > 0) {
      this.IsShow_AnnualOutingVisit = (userPermissionData_IsShow_AnnualOutingVisit[0].showPage == 1) ? true : false;
    }

    let userPermissionData_IsShow_PerformanceBenchmarkDashboard = this.userService.getUserRights("Performance Benchmark Dashboard");
    if (userPermissionData_IsShow_PerformanceBenchmarkDashboard != null && userPermissionData_IsShow_PerformanceBenchmarkDashboard != undefined && userPermissionData_IsShow_PerformanceBenchmarkDashboard.length > 0) {
      this.IsShow_PerformanceBenchmarkDashboard = (userPermissionData_IsShow_PerformanceBenchmarkDashboard[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_PracticeBMDashboard = this.userService.getUserRights("Practice BM Dashboard");
    if (userPermissionData_IsShow_PracticeBMDashboard != null && userPermissionData_IsShow_PracticeBMDashboard != undefined && userPermissionData_IsShow_PracticeBMDashboard.length > 0) {
      this.IsShow_PracticeBMDashboard = (userPermissionData_IsShow_PracticeBMDashboard[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_IncomingBMdashboard = this.userService.getUserRights("Incoming BM dashboard");
    if (userPermissionData_IsShow_IncomingBMdashboard != null && userPermissionData_IsShow_IncomingBMdashboard != undefined && userPermissionData_IsShow_IncomingBMdashboard.length > 0) {
      this.IsShow_IncomingBMdashboard = (userPermissionData_IsShow_IncomingBMdashboard[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_OutgoinginternalBMDashboard = this.userService.getUserRights("Outgoing/internal BM Dashboard");
    if (userPermissionData_IsShow_OutgoinginternalBMDashboard != null && userPermissionData_IsShow_OutgoinginternalBMDashboard != undefined && userPermissionData_IsShow_OutgoinginternalBMDashboard.length > 0) {
      this.IsShow_OutgoinginternalBMDashboard = (userPermissionData_IsShow_OutgoinginternalBMDashboard[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_AwarenessSession = this.userService.getUserRights("Awareness Session");
    if (userPermissionData_IsShow_AwarenessSession != null && userPermissionData_IsShow_AwarenessSession != undefined && userPermissionData_IsShow_AwarenessSession.length > 0) {
      this.IsShow_AwarenessSession = (userPermissionData_IsShow_AwarenessSession[0].showPage == 1) ? true : false;
    }
    let userPermissionData_IsShow_AddincomingBMrequest = this.userService.getUserRights("Awareness Session");
    if (userPermissionData_IsShow_AddincomingBMrequest != null && userPermissionData_IsShow_AddincomingBMrequest != undefined && userPermissionData_IsShow_AddincomingBMrequest.length > 0) {
      this.IsShow_AddincomingBMrequest = (userPermissionData_IsShow_AddincomingBMrequest[0].showPage == 1) ? true : false;
    }

    let userPermissionData_IsShow_BMRequest = this.userService.getUserRights("BM Request");
    if (userPermissionData_IsShow_BMRequest != null && userPermissionData_IsShow_BMRequest != undefined && userPermissionData_IsShow_BMRequest.length > 0) {
      this.IsShow_BMRequest = (userPermissionData_IsShow_BMRequest[0].showPage == 1) ? true : false;
    }

    //let userPermissionData_IsShow_BMIncomingRequest = this.userService.getUserRights("Incoming BM Request");
    //if (userPermissionData_IsShow_BMIncomingRequest != null && userPermissionData_IsShow_BMIncomingRequest != undefined && userPermissionData_IsShow_BMIncomingRequest.length > 0) {
    //  this.IsShow_BMIncomingRequest = (userPermissionData_IsShow_BMIncomingRequest[0].showPage == 1) ? true : false;
    //}

    let userPermissionData_IsShow_BMOutgoingRequest = this.userService.getUserRights("Outgoing BM Request");
    if (userPermissionData_IsShow_BMOutgoingRequest != null && userPermissionData_IsShow_BMOutgoingRequest != undefined && userPermissionData_IsShow_BMOutgoingRequest.length > 0) {
      this.IsShow_BMOutgoingRequest = (userPermissionData_IsShow_BMOutgoingRequest[0].showPage == 1) ? true : false;
    }

    let userPermissionData_IsShow_FileManager = this.userService.getUserRights("File Manager");
    if (userPermissionData_IsShow_FileManager != null && userPermissionData_IsShow_FileManager != undefined && userPermissionData_IsShow_FileManager.length > 0) {
      this.IsShow_FileManager = (userPermissionData_IsShow_FileManager[0].showPage == 1) ? true : false;
    }


  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.businessDeptUno = 0;
    this.businessDivisionUno = 0;
    this.trendUno = 0;
  //  this.loadFilterValues();
    //this.getDivisions();
    //this.getDepartments();
    //this.getTrend();
   
  }

  loadFilterValues() {
    
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;        
        this.yearData = objdata.list_YearMaster;

        //this.onLoadDashboard();
       
        // this.spinner.hide();
      },
        (error) => {
          //Called when error
         // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID ;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = 1;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getDepartments() {

    let inpValue = new department();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getDepartments(inpValue)
      .subscribe(data => {

        this.department_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getTrend() {
    this.trend_data = [
      { trendUno: 1, trendName: 'Achievement' },
      { trendUno: 2, trendName: 'Reduction' }
    ];
  }

  onchangeYear(e) {

    this.yearUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    this.onLoadDashboard();
  }

  onchangeDivision(e) {
    
    this.businessDivisionUno = (e && e.length > 0 && e[0].value!=null) ? e[0].value : 0;
    this.onLoadDashboard();
  }
  onchangeDepartment(e) {

    this.businessDeptUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    this.onLoadDashboard();
  }
  onchangeTrend(e) {

    this.trendUno = (e && e.length > 0 && e[0].value != null) ? e[0].value : 0;
    this.onLoadDashboard();
  }

  public onLoadDashboard() {
    this.spinner.show();
    let inpValue = new bmdashboardFilterValue();
    inpValue.yearuno = this.yearUno;
    inpValue.businessDivisionUno = (typeof this.businessDivisionUno != 'undefined' && this.businessDivisionUno) ? this.businessDivisionUno :0;
    inpValue.businessDeptUno = (typeof this.businessDeptUno != 'undefined' && this.businessDeptUno) ? this.businessDeptUno : 0;
    inpValue.trendUno = (typeof this.trendUno != 'undefined' && this.trendUno) ? this.trendUno : 0;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.getBMDashboard(inpValue)
      .subscribe(data => {
        let objdata: any = data;
        this.count_data = objdata.countData;
        this.position_data = objdata.positionData;
        this.peer_data = objdata.peerData;
        this.map_data = objdata.mapData;
        

        google.charts.load('current', { 'packages': ['corechart'] });
        google.charts.setOnLoadCallback(this.benchmarkincomingoutgoingchart1bmn);
        google.charts.setOnLoadCallback(this.benchmarkincomingoutgoingchart2bmn);
        google.charts.load('current', {
          'packages': ['geochart'],
          'mapsApiKey': 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY'
        });
        google.charts.setOnLoadCallback(this.benchmarkincomingoutgoingchartworldbmn);

        this.spinner.hide();
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });

  }
  benchmarkincomingoutgoingchart1bmn = () => {
    let tempArray = [['Position', 'Value']];
    for (var i = 0; i < this.position_data.length; i++) {
      tempArray.push([this.position_data[i].positionName, this.position_data[i].actualValue]);
    }
    const data = google.visualization.arrayToDataTable(tempArray);
    /*[
      ['Sample size', 'positioning'],
      ['Top Decile', 11],
      ['Top Quartile', 2],
      ['Median', 2],
      ['Bottom Quartile', 2]


    ]*/
    const options = {
      title: 'Positioning against Sample Size',
      pieHole: 0.4,
      colors: ['#006600', '#339933', '#ffc000', '#c00000']
    };

    const chart = new google.visualization.PieChart(document.getElementById('benchmarkincomingoutgoingchart1bmn'));
    chart.draw(data, options);
  }


  benchmarkincomingoutgoingchart2bmn = () => {
    let tempArray = [['Peer', 'Value']];
    for (var i = 0; i < this.peer_data.length; i++) {
      tempArray.push([this.peer_data[i].peerName, this.peer_data[i].actualValue]);
    }
    const data = google.visualization.arrayToDataTable(tempArray);

    const options = {
      title: 'Individual Peer',
      pieHole: 0.4,
      colors: ['#339966', '#ffff00', '#ff0000']
    };

    const chart = new google.visualization.PieChart(document.getElementById('benchmarkincomingoutgoingchart2bmn'));
    chart.draw(data, options);
  }


  benchmarkincomingoutgoingchartworldbmn = () => {
    let tempArray = [['Country', 'Popularity']];
    for (var i = 0; i < this.map_data.length; i++) {
      tempArray.push([this.map_data[i].country, this.peer_data[i].noofPeer]);
    }
    const data = google.visualization.arrayToDataTable(tempArray);
/*[
      ['Country', 'Popularity'],
      ['Germany', 200],
      ['United States', 300],
      ['Brazil', 400],
      ['Canada', 500],
      ['France', 600],
      ['RU', 700]

    ]*/
    const options = {
      //title: 'DEWA Benchmarking position categories against peers',

    };

    const chart = new google.visualization.GeoChart(document.getElementById('benchmarkincomingoutgoingchartworldbmn'));
    chart.draw(data, options);
  }
 

  redirectToBenchMarkMasters(type: any) {


    this.router.navigate(['/performancemaster'], { queryParams: { pfmtype: type } });

    if (type == 'surveyOption') {
      this.router.navigate(['/survey-option-master']);
    }

    if (type == 'surveyQuestion') {
      this.router.navigate(['/survey-question-master']);
    }

    if (type == 'practice') {
      this.router.navigate(['/practice-bm-progress-master']);
    }
    
    //document.querySelector(type).classList.add('current-page');
    return false;

  }

 }


